import { render, staticRenderFns } from "./AboutThisVessel.vue?vue&type=template&id=42f267e2&scoped=true"
import script from "./AboutThisVessel.vue?vue&type=script&lang=js"
export * from "./AboutThisVessel.vue?vue&type=script&lang=js"
import style0 from "./AboutThisVessel.vue?vue&type=style&index=0&id=42f267e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f267e2",
  null
  
)

export default component.exports